export enum ColPath {
  organizations = "users/organizations",
  organizationAssets = "users/organizations/assets",
  projects = "users/organizations/projects",
  projectsAssets = "users/organizations/projects/assets",
  milestones = "users/organizations/projects/assets/milestones"
}
